'use client';

import { FC, SyntheticEvent, useEffect } from 'react';

import { Grid, Notification, Paragraph } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { AxiosCartError, CartError } from '@telialt/models/src/EshopModel';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { ClientSideErrorContainer } from './ClientSideError.styles';

type Props = {
    error?: AxiosCartError | CartError | Error;
    component?: DDComponent;
};

export const ClientSideError: FC<Props> = ({ error, component = DDComponent.Eshop }) => {
    const { t } = useTranslations();
    useEffect(() => {
        const errorMessage = error?.message || (error as CartError)?.type;

        const datadogLogs = datadogLogger();
        datadogLogs.error(`EShop page error: ${errorMessage}`, { error, component });
    }, [component, error]);

    const handleOnClick = (event: SyntheticEvent<HTMLElement>) => {
        event.preventDefault();
        window.location.reload();
    };

    return (
        <ClientSideErrorContainer>
            <Grid>
                <Notification status="error" headingTag="h1" heading={t['eshop.common.client_side_error.title']}>
                    <Paragraph enableHyphenation={false} slot="content">
                        {t['eshop.common.client_side_error.description']}
                        <br />
                        <a href="#refresh" onClick={handleOnClick}>
                            {t['eshop.common.client_side_error.action']}
                        </a>
                    </Paragraph>
                </Notification>
            </Grid>
        </ClientSideErrorContainer>
    );
};
